import { getFullURL } from './endpoints';

export function generatePatientRoomURL(code: string): string {
  return getFullURL('/' + code);
}

export function generateGroupRoomURL(code: string): string {
  return getFullURL('/' + code);
}
export function titleCase(str: string): string {
  return str.replace(/\w\S*/g, match => match.charAt(0).toUpperCase() + match.substring(1).toLowerCase());
}
